export enum PropertyType {
  Commercial = 'Commercial',
  Residential = 'Residential',
}
